import { useEffect, useRef } from 'react'
import NextImage from 'next/image'
import styles from './styles.module.scss'
import useIntersectionObserver from '@helpers/hooks/useIntersectionObserver'

export default function Hero() {
  const titleRef = useRef<HTMLHeadingElement | null>(null)
  const imageRef = useRef<HTMLImageElement | null>(null)
  const heroIsIntersectingRef = useRef(false)

  const onIntersectHero: IntersectionObserverCallback = ([entry]) => {
    heroIsIntersectingRef.current = entry.isIntersecting
  }

  useIntersectionObserver({
    elementIdentifier: '#hero',
    options: { threshold: 0.1 },
    onIntersect: onIntersectHero
  })

  useEffect(() => {
    const onScroll = () => {
      const scrollY = window.scrollY
      if (heroIsIntersectingRef.current) {
        window.requestAnimationFrame(() => {
          if (titleRef.current && imageRef.current) {
            titleRef.current.style.transform = `translateX(-${Math.round(
              scrollY / 2
            )}px)`
            imageRef.current.style.transform = `translateX(${Math.round(
              scrollY / 5
            )}px)`
          }
        })
      }
    }
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  return (
    <section className={styles.Hero} id="hero">
      <div className={styles.Hero__container}>
        <h2 ref={titleRef} className={styles.Hero__title}>
          <p>
            Clothes that <span>go the distance... </span>
          </p>
          <p>
            Clothes that <span>go the distance... </span>
          </p>
          <p>
            Clothes that <span>go the distance...</span>
          </p>
        </h2>
        <NextImage
          width="500"
          height="500"
          className={styles.Hero__image}
          ref={imageRef}
          src="/static/images/enduros/enduros_man.png"
          alt="Man with Enduros trousers"
        />
        <div className={styles.Hero__copy}>
          <p>
            Our Enduros collide cutting-edge design with magical materials and
            clever trims — reimagining our classics as high-performance pieces.
          </p>
          <p>
            These will glide through work trips and packed weekend agendas,
            emerging from long haul flights — and even the most crudely packed
            carry-ons — razor-sharp and wrinkle-free.
          </p>
          <p>
            Sartorial sorcery. Tomorrow trousering. And there’s a shirt too...
          </p>
        </div>
      </div>
    </section>
  )
}
